import MuiCard, { CardProps as MuiCardProps } from '@mui/material/Card';
import * as React from 'react';

export interface CardProps extends MuiCardProps {}

export const Card = (props: CardProps) => {
  return <MuiCard {...props} />;
};
